import React, { useState } from 'react';
import SearchImage from '../../../assets/images/Search.svg';
// import { setSectionId } from '../../../redux/actions/user';
import style from './CounterpartySearch.module.scss';
import { suppliersValidation } from './validation';

interface IProps {
  onSubmit: (searchValue: string) => void;
  slug: any;
}

const CounterpartySearch: React.FC<IProps> = ({ onSubmit, slug }: IProps) => {
  const [searchValue, setSearchValue] = useState<any>(slug || '');
  const [isCodeError, setCodeError] = useState({ isError: false, errorMessage: '', showError: true });

  React.useEffect(() => {
    if (!slug) {
      const inn = JSON.parse(localStorage.getItem('innRouter') || '{}');
      if (typeof inn === 'string') {
        setSearchValue(inn);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = async () => {
    if (searchValue.trim() === '') {
      setCodeError({ isError: true, errorMessage: 'Введите ИНН или ОГРН', showError: true });
      return;
    }
    setCodeError({ isError: false, errorMessage: '', showError: false });
    if (!suppliersValidation(searchValue)) {
      setCodeError({ isError: true, errorMessage: 'Введите корректный ИНН или ОГРН', showError: true });
      return;
    }
    setCodeError({ isError: false, errorMessage: '', showError: false });

    onSubmit(searchValue.trim());
  };

  return (
    <form className={style.searchContainer}>
      <h3 className={style.title}>Введите ИНН или ОГРН организации</h3>

      <div className={style.search}>
        <div className={style.group}>
          <input
            type="search"
            className={style.searchInput}
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value.replace(/[^0-9]/g, ''))}
            onBlur={() => setCodeError((prev) => ({ ...prev, showError: false }))}
            onFocus={() => {
              if (searchValue.trim() !== '') setCodeError((prev) => ({ ...prev, showError: true }));
            }}
          />
          {isCodeError.isError && isCodeError.showError && (
            <div className={style.error}>{isCodeError.errorMessage}</div>
          )}
        </div>
        <button
          type="submit"
          className={style.searchButton}
          onClick={(event) => {
            event.preventDefault();
            handleClick();
            setTimeout(() => {
              setCodeError((prev) => ({ ...prev, showError: false }));
            }, 5000);
            localStorage.clear();
          }}
        >
          <img src={SearchImage} alt="Поиск" className={style.searchImage} />
          Сформировать отчёт
        </button>
      </div>
    </form>
  );
};

export default CounterpartySearch;
